import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg className={(styles["codicon"] || "codicon") + " " + (styles["codicon-list"] || "codicon-list")} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.93 24.93" {...props}><path d="M0 0h24.92v4.21H0zM0 10.36h24.92v4.21H0zM0 20.72h24.92v4.21H0z" /></svg>;